import React from 'react';
import './Offer.less';
import {OfferTitle} from "elements/offer-title/OfferTitle";
import {OfferDescription} from "elements/offer-description/OfferDescription";

export const Offer = ({title, description}) => {
	return <div className="offer">
		<div className="offer__title">
			<OfferTitle text={title}/>
		</div>
		<div className="offer__description">
			<OfferDescription text={description}/>
		</div>
	</div>
}
